import React from 'react';
import Pages from './basic_page';
class Team extends Pages {
    render() {
        return (
    <>
            <h1 className='des_team' >
                Team Member
            </h1>
        <div className='pageholder'>
            <div className='righttext'>
                <div className='Peoplelayer'>
                    <div className='photo'><img src="https://static.igem.wiki/teams/4298/wiki/team-lizhuoran.png" /></div>
                    <div className='text'>
                        <h4>Zhuoran Li</h4>
                        <p>Major: Integrated Science</p>
                        <p>Hobbies: Piano, Yo-yo</p>
                        <p>Have been long time in the field of scientific research, I am curious about what is happening in the industry of Synthetic biology, also, I have enough time to participate in iGEM this year.</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>
                    <div className='photo2'><img src="https://static.igem.wiki/teams/4298/wiki/team-zhangdaijian.png" /></div>
                    <div className='text2'>
                        <h4>Daijian Zhang</h4>
                        <p>Major: Life sciences</p>
                        <p>Hobbies: Outdoor cycling, Rap</p>
                        <p>I am mainly attracted by the free and independent atmosphere of iGEM. I hope I can choose a project and try to realize it. At the same time, I can improve my ability and make some friends.</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>
                    <div className='photo'><img src="https://static.igem.wiki/teams/4298/wiki/team-chenzuizhi.png" /></div>
                    <div className='text'>
                        <h4>Zuizhi Chen</h4>
                        <p>Major: Life Sciences, Bioinformatics</p>
                        <p>Sunny and cheerful, like basketball and games. Usually, I like to stay in the dormitory and watch my mobile phone, unless someone invites me to play outside, such as playing basketball. Usually I am lazy, but I will finish my responsible work well. Before participating in the igem competition, I prefer the dry experiment part, and now I think the wet experiment is also very interesting.</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>
                    <div className='photo2'><img src="https://static.igem.wiki/teams/4298/wiki/team-cuijiatong.png" /></div>
                    <div className='text2'>
                        <h4>Jiatong Cui</h4>
                        <p>Major：Life Science，Ecology</p>
                        <p>Hobbies：Squamata，monsters movies，specimens，TRPG</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>

                    <div className='photo' ><img src="https://static.igem.wiki/teams/4298/wiki/team-zhaomasixuan.png" /></div>
                    <div className='text'>
                        <h4>Masixuan Zhao</h4>
                        <p>Major：Life Science</p>
                        <p>Hobbies：Life cultivation and health preservation, Soccer, Fencing, Steam，Arknights, Detective story, Bridge </p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>
                    <div className='photo2'><img src="https://static.igem.wiki/teams/4298/wiki/team-mayishan.png" /></div>
                    <div className='text2'>
                        <h4>Yishan Ma</h4>
                        <p>Major：Nursing</p>
                        <p>Hobby：Reading novels，Writing</p>
                        <p>I want to participate in a scientific research project, experience scientific research, broaden my horizon, expand my knowledge, and make some new friends.</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>
                    <div className='photo'><img src="https://static.igem.wiki/teams/4298/wiki/team-libuyao.png" /></div>
                    <div className='text'>
                        <h4>Buyao Li</h4>
                        <p>Major: Pharmaceutical Science</p>
                        <p>Hobby: Handiwork, Movies</p>
                        <p>Synthetic biology has been very attractive to me for a long time, so I participated in this year's iGEM, focusing on using it to solve medical problems.</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>
                    <div className='photo2'><img src="https://static.igem.wiki/teams/4298/wiki/team-shixingyu.png" /></div>
                    <div className='text2'>
                        <h4>Xingyu Shi</h4>
                        <p>Major: Physiology and Neurobiology</p>
                        <p>I have a variety of interests in biology, especially in the origin and evolution of human beings. In addition, I am a travel enthusiast, especially paying attention to the railway travel.</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>
                    <div className='photo'><img src="https://static.igem.wiki/teams/4298/wiki/team-zhouzhenyi.png" /></div>
                    <div className='text'>
                        <h4>Zhenyi Zhou</h4>
                        <p>Major: Bioinformatics</p>
                        <p>How to integrate Peking iGEM project into the daily moment of human beings in order to change the social prospect is my goal to pursue. I love to write and read widely, Calvino's Tutte le cosmicomiche is my favorite. “The beauty of life is being totally sucked in and forgetting”，I think it applies to a lot of things I am doing.</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>
                    <div className='photo2'><img src="https://static.igem.wiki/teams/4298/wiki/hfk.jpg" /></div>
                    <div className='text2'>
                        <h4>Fangkai Hu</h4>
                        <p>Major: Bioinformatics</p>
                        <p><s>(A Bitter Programmer)</s></p>
                        <p>Have a desire to go to bed early and get up early</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div className='Peoplelayer'>
                    <div className='photo'><img src="https://static.igem.wiki/teams/4298/wiki/team-wangyiru.png" /></div>
                    <div className='text'>
                        <h4>Yiru Wang</h4>
                        <p>Major: Life Science</p>
                        <p>Hobby: Drawing, Reading, Handiwork</p>
                        <p>It's fantastic to see people recover from the diseases which have tortured them for years, so I participated in iGEM, hoping to find a solution. </p>
                    </div>
                </div>
            </div>
		</div>
    </>

  );
    }
};

export default Team;
